// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/common.scss';
import axios from 'axios'
import urls from '@/api/apiUrl.js';
import jsonUrls from '@/api/jsonUrl.js';
import 'babel-polyfill'
import "@/styles/public.css"
import './assets/icon/iconfont.css'
import "@/styles/page.css"
// import '@/common/rem.js';
import bus from '@/common/eventBus.js';
import commonMethods from '@/common/commonMethods.js';

import Navs from '../src/components/pc/common/navs/NavsP.vue';
import PageNav from '../src/components/pc/common/page-nav/PageNavP.vue';
import AdvComponentP from '../src/components/pc/common/advertising/AdvertisingComponentP.vue';
import WebAdvComponentP from '../src/components/pc/common/advertising/WebAdvertisingComponentP.vue';
import PopupP from '../src/components/pc/common/popup/PopUpP.vue';
import PopupM from '../src/components/mobile/common/popup/PopupM.vue';

import {store} from '@/vuex/store.js';

// 导航栏
Vue.component('Navs', Navs);
// 页面地址导航
Vue.component('PageNav', PageNav);
// 广告展示
Vue.component('AdvertisingP', AdvComponentP);
Vue.component('WebAdvertisingP', WebAdvComponentP);
// 信息弹窗
Vue.component('PopupP', PopupP);
Vue.component('PopupM', PopupM);

Vue.prototype.$axios = axios;
Vue.prototype.urls = urls;
Vue.prototype.jsonUrls = jsonUrls;
Vue.prototype.Bus = bus;
Vue.prototype.cm = commonMethods;
Vue.config.productionTip = false
Vue.use(ElementUI);

import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
}
/* eslint-disable no-new */

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>',
    store
})


// WEBPACK FOOTER //
// ./src/main.js